import React, { useEffect, useMemo, useState } from 'react';
import '../styles/UserAvatar.css';

export const getAvatarInitials = (name, email) => {
  const source = String(name || '').trim();

  if (source) {
    const parts = source.split(/\s+/).filter(Boolean);
    return parts
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase();
  }

  return String(email || '?').trim().charAt(0).toUpperCase() || '?';
};

export const resolveUserPhotoURL = (profile, authUser) =>
  profile?.photoURL || authUser?.photoURL || null;

const UserAvatar = ({
  photoURL,
  fallbackPhotoURL,
  name,
  email,
  size = 40,
  className = '',
  alt,
  loading = 'lazy',
  onClick,
  onLoad,
}) => {
  const resolvedPhotoURL = photoURL || fallbackPhotoURL || null;
  const [imageFailed, setImageFailed] = useState(false);
  const initials = useMemo(() => getAvatarInitials(name, email), [email, name]);

  useEffect(() => {
    setImageFailed(false);
  }, [resolvedPhotoURL]);

  const style = {
    '--user-avatar-size': `${size}px`,
  };
  const classes = `user-avatar ${onClick ? 'user-avatar--clickable' : ''} ${className}`.trim();
  const accessibleAlt = alt || `Фото профілю ${name || email || 'користувача'}`;

  const content = resolvedPhotoURL && !imageFailed ? (
    <img
      src={resolvedPhotoURL}
      alt={accessibleAlt}
      width={size}
      height={size}
      loading={loading}
      onLoad={onLoad}
      onError={() => setImageFailed(true)}
    />
  ) : (
    <span className="user-avatar__initials" aria-label={accessibleAlt}>
      {initials}
    </span>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={classes}
        style={style}
        onClick={onClick}
        aria-label={accessibleAlt}
      >
        {content}
      </button>
    );
  }

  return (
    <span className={classes} style={style}>
      {content}
    </span>
  );
};

export default UserAvatar;
